import { render } from "./Guardian.vue?vue&type=template&id=3b46ac26&scoped=true"
import script from "./Guardian.vue?vue&type=script&lang=js"
export * from "./Guardian.vue?vue&type=script&lang=js"

import "./Guardian.vue?vue&type=style&index=0&id=3b46ac26&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b46ac26"]])

export default __exports__